<template>
  <div class="market-box">
    <small>Ausgewählter REWE Markt</small>
    <span v-if="thisMarket"
      >{{ thisMarket.address.street }}, {{ thisMarket.address.zip }}
      {{ thisMarket.address.city }}</span
    >
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "market-infos-box",
  components: {},
  props: {
    format: {
      required: false
    },
    customMarket: {
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["market"]),
    thisMarket() {
      if (this.customMarket) {
        return this.customMarket;
      } else {
        return this.market;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../scss/settings";
.market-box {
  width: 100%;
  border-radius: 4px;
  padding: 15px 17px 20px 17px;
  background: $dark-bg;
  position: relative;
  @include fontMedium;
  font-size: px-to-rem(18);
  color: #ffffff;
  small {
    @include fontDefault;
    font-size: px-to-rem(14);
    color: #ffffff;
    display: block;
    margin-bottom: 10px;
  }
}
</style>